import { gql } from "@apollo/client";

export const DELETE_COMMENT = gql`
  mutation deleteComment($commentID: String!) {
    deleteComment(commentID: $commentID) {
      status
    }
  }
`;
